<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template #headerTitle>
            <h5 class="card-title text-primary">
              <strong
                >{{
                  $route.query?.detail
                    ? 'DETAIL'
                    : isExistFleet
                    ? 'UPDATE'
                    : 'CREATE'
                }}
                SERVICE & REPAIR</strong
              >
            </h5>
          </template>
          <template #body>
            <div class="">
              <template v-if="$route.query.detail">
                <b-row>
                  <b-col lg="6">
                    <b-row class="align-items-center">
                      <b-col class="mb-3" md="5">Fleet</b-col>
                      <b-col class="mb-3 text-black" md="7">
                        {{
                          fleetsOptions.find(
                            (el) => el.value == form.vehicle_id
                          )?.text ?? '-'
                        }}</b-col
                      >
                      <b-col class="mb-3" md="5">Location</b-col>
                      <b-col class="mb-3 text-black" md="7">{{
                        form.location ?? '-'
                      }}</b-col>
                      <b-col class="mb-3" md="5">Site / Work Loacation</b-col>
                      <b-col class="mb-3 text-black" md="7">{{
                        form.site ?? '-'
                      }}</b-col>
                      <b-col class="mb-3" md="5">Date Service & Repair</b-col>
                      <b-col class="mb-3 text-black" md="7">{{
                        formatDate(form.accident_at)
                      }}</b-col>
                      <b-col class="mb-3" md="5">Est. Start Date</b-col>
                      <b-col class="mb-3 text-black" md="7">{{
                        formatDate(form.start_date_est)
                      }}</b-col>
                      <b-col class="mb-3" md="5">Est. Finist Date</b-col>
                      <b-col class="mb-3 text-black" md="7">{{
                        formatDate(form.finish_date_est)
                      }}</b-col>
                      <b-col class="mb-3" md="5"
                        >Est. Cost Service & Repair</b-col
                      >
                      <b-col class="mb-3 text-black" md="7">{{
                        formatCurrency(form.cost_est) ?? '-'
                      }}</b-col>
                      <template v-if="form.finish_date_real">
                        <b-col class="mb-3" md="5">Real Start Date</b-col>
                        <b-col class="mb-3 text-black" md="7">{{
                          formatDate(form.start_date_real)
                        }}</b-col>
                      </template>
                      <template v-if="form.start_date_real">
                        <b-col class="mb-3" md="5">Real Finish Date</b-col>
                        <b-col class="mb-3 text-black" md="7">{{
                          formatDate(form.finish_date_real)
                        }}</b-col>
                      </template>
                      <template v-if="form.cost_real">
                        <b-col class="mb-3" md="5"
                          >Real Cost Service & Repair</b-col
                        >
                        <b-col class="mb-3 text-black" md="7">{{
                          formatCurrency(form.cost_real) ?? '-'
                        }}</b-col>
                      </template>
                    </b-row>
                  </b-col>
                  <b-col lg="6">
                    <b-row>
                      <b-col class="mb-3" md="12"
                        >Attachment Service & Repair</b-col
                      >
                      <b-col class="mb-3 text-black" md="12">
                        <b-row class="m-0">
                          <b-col
                            md="3"
                            class="p-1 pr-2"
                            v-for="(item, index) in form.filePreview"
                            :key="index"
                          >
                            <AttachmentSR
                              @success-delete="deleteFile"
                              :modelId="form.id"
                              modelName="sr_form"
                              :file="item"
                              @delete="() => handleDeleteFile(item, index)"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="mb-2" md="12">Description</b-col>
                      <b-col class="mb-3 text-black" md="12">
                        {{ form.remark ?? '-' }}
                      </b-col>
                      <b-col class="mb-3" md="12">Vessel PIC</b-col>
                      <b-col
                        class="mb-3 text-black d-flex align-items-center"
                        md="12"
                      >
                        <b-avatar variant="warning"></b-avatar>
                        <div class="ml-2">
                          <p class="mb-0">{{ form.pic ?? '-' }}</p>
                          <!-- <small>-</small> -->
                        </div>
                      </b-col>
                      <b-col class="mb-3" md="12">Status</b-col>
                      <b-col class="mb-3" md="12">
                        <b-badge
                          v-if="form.status"
                          :variant="`${
                            form?.status === 'new'
                              ? 'info'
                              : form.status === 'review'
                              ? 'primary'
                              : form.status === 'approved'
                              ? 'success'
                              : form.status === 'progress'
                              ? 'warning'
                              : 'danger'
                          } d-block`"
                          style="width: max-content"
                          >{{ form?.status }}</b-badge
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <div v-else class="border p-3 card-sr-information-form">
                <b-row v-if="!$route.query?.finish">
                  <b-col md="3" class="mb-3">
                    <label for="fleets">Fleet</label>
                    <b-form-select
                      plain
                      name="fleets"
                      id="fleets"
                      v-model="form.vehicle_id"
                      :options="fleetsOptions"
                    ></b-form-select>
                    <!-- <p v-else class="mb-0">{{
                      fleetsOptions.find((el) => el.value == form.vehicle_id)
                        ?.text ?? '-'
                    }}</p> -->
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="location">Accident Location</label>
                    <b-input
                      id="loaction"
                      class="bg-white"
                      v-model="form.location"
                    ></b-input>
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="date"
                      >Accident Date <span class="text-danger">*</span></label
                    >
                    <date-picker
                      id="date"
                      class="w-100"
                      v-model="form.accident_at"
                    ></date-picker>
                    <small class="text-danger" v-if="formErr?.accident_at"
                      >this field required</small
                    >
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="work-location">Site / Work Location</label>
                    <b-input
                      id="work-location"
                      v-model="form.site"
                      class="bg-white w-100"
                    ></b-input>
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="pic">Fleet PIC</label>
                    <v-select
                      :options="usersPic"
                      v-model="form.pic_id"
                      class="bg-white"
                      label="label"
                      :reduce="(opt) => opt.id"
                      @input="(val) => onInputPic(val, form)"
                    >
                      <template #option="{ userDetail, email }">
                        <div class="d-flex justify-center">
                          <b-avatar
                            :src="userDetail?.photo"
                            variant="warning"
                            class="mr-2"
                          ></b-avatar>
                          <div>
                            <p class="mb-0 black">{{ userDetail?.name }}</p>
                            <small class="mb-0 black">{{ email }}</small>
                          </div>
                        </div>
                      </template>
                      <template #selected-option="{ userDetail }">
                        <div class="d-flex align-items-center">
                          <b-avatar
                            :src="userDetail?.photo"
                            variant="warning"
                            class="mr-2"
                            size="sm"
                          ></b-avatar>
                          <p class="mb-0 black">{{ userDetail?.name }}</p>
                        </div>
                      </template>
                    </v-select>
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="work-location"
                      >Est. Cost Service & Repair</label
                    >
                    <InputCurrency v-model="form.cost_est" disabled />
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label>Est. Start Date</label>
                    <date-picker
                      id="date"
                      class="w-100"
                      v-model="form.start_date_est"
                    ></date-picker>
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label>Est. Finish Date</label>
                    <date-picker
                      id="date"
                      class="w-100"
                      v-model="form.finish_date_est"
                      :disabled-date="
                        (date) => disableEndDate(date, form.start_date_est)
                      "
                      :disabled="!form.start_date_est"
                    ></date-picker>
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="attachment">Attachment Service & Repairs</label>
                    <InputFileMultiple
                      labelKey="input-file-sr-form"
                      :files="form.filePreview"
                      @change-files="(val) => handleInputFiles(val, form)"
                    ></InputFileMultiple>
                    <b-row class="m-0">
                      <b-col
                        lg="6"
                        class="p-1 pr-2"
                        v-for="(item, index) in form.filePreview"
                        :key="index"
                      >
                        <AttachmentSR
                          @success-delete="deleteFile"
                          :modelId="form.id"
                          modelName="sr_form"
                          :file="item"
                          @delete="() => handleDeleteFile(item, index)"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12">
                    <label for="remark">Remarks</label>
                    <b-form-textarea
                      id="remark"
                      placeholder="input remarks..."
                      rows="3"
                      class="bg-white"
                      v-model="form.remark"
                    ></b-form-textarea>
                    <!-- <p>{{ form.remark ?? '-' }}</p> -->
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col md="3" class="mb-3">
                    <label for="date">Start Date Realization</label>
                    <date-picker
                      id="date"
                      class="w-100"
                      v-model="form.start_date_real"
                    ></date-picker>
                    <!-- <p v-else class="mb-0">{{
                      moment(form.accident_at).format('DD MMM YYYY') ?? '-'
                    }}</p> -->
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="date">Finish Date Realization</label>
                    <date-picker
                      id="date"
                      class="w-100"
                      v-model="form.finish_date_real"
                      :disabled-date="
                        (date) => disableEndDate(date, form.start_date_real)
                      "
                      :disabled="!form.start_date_real"
                    ></date-picker>
                    <!-- <p v-else class="mb-0">{{
                      moment(form.accident_at).format('DD MMM YYYY') ?? '-'
                    }}</p> -->
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="work-location"
                      >Real Cost Service & Repair</label
                    >
                    <InputCurrency v-model="form.cost_real" :disabled="true" />
                  </b-col>
                  <b-col md="3" class="mb-3">
                    <label for="attachment">Attachment Service & Repairs</label>
                    <InputFileMultiple
                      label="input-file-sr-form-finish"
                      :files="form.filePreview"
                      @change-files="(val) => handleInputFiles(val, form)"
                    ></InputFileMultiple>
                    <b-row class="m-0">
                      <b-col
                        lg="6"
                        class="p-1 pr-2"
                        v-for="(item, index) in form.filePreview"
                        :key="index"
                      >
                        <AttachmentSR
                          @success-delete="deleteFile"
                          :modelId="form.id"
                          modelName="sr_form"
                          :file="item"
                          @delete="() => handleDeleteFile(item, index)"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12">
                    <label for="remark-finish">Remarks Finish</label>
                    <b-form-textarea
                      id="remark-finish"
                      placeholder="input remarks finish..."
                      rows="3"
                      v-model="form.remark_finish"
                      class="bg-white"
                    ></b-form-textarea>
                    <!-- <p>{{ form.remark ?? '-' }}</p> -->
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt-3">
                <b-col md="12" class="my-3">
                  <ListItemSR
                    :headerForm="form"
                    :headerFormErr="formErr"
                    @existFleet="isExistFleet = true"
                    :fleetSelected="fleetSelected"
                  />
                </b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { fleetsActions, usersActions } from '@/src/Utils/helper'
import ListItemSR from './components/ListItemSR.vue'
import moment from '@/node_modules/moment/moment'
import AttachmentSR from './components/AttachmentSR.vue'
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import InputFileMultiple from '@/src/components/global/InputFileMultiple.vue'

export default {
  name: 'ServiceRepairForm',
  components: {
    ListItemSR,
    AttachmentSR,
    InputCurrency,
    InputFileMultiple,
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
      fleetsOptions: [],
      isExistFleet: false,
      fleetSelected: null,
      usersPic: [],
      form: {
        id: null,
        vehicle_id: this.$route.query?.vehicleId,
        accident_at: null,
        date_finish_est: null,
        start_date_est: null,
        finish_date_est: null,
        start_date_real: null,
        finish_date_real: null,
        location: '',
        site: '',
        pic: '',
        pic_id: '',
        cost_est: null,
        cost_real: null,
        remark: '',
        remark_finish: '',
        user_id: JSON.parse(localStorage.getItem('profile')).id,
        user_name: JSON.parse(localStorage.getItem('profile')).userDetail.name,
        created_by: JSON.parse(localStorage.getItem('profile')).id,
        updated_by: null,
        type_of_job: 'equipment_init',
        filePreview: [],
        deleted_files: [],
        files: [],
        status: '',
      },
      formErr: {
        accident_at: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...usersActions,
    disableEndDate(date, value) {
      if (!value) return true
      return date < new Date(value)
    },
    async fetchPic() {
      try {
        const params = {
          page: 1,
          perPage: 9999,
          active: true,
          user_id: this.user_id,
        }
        const res = await this.getUsers(params)
        this.usersPic = res.data.data.map((el) => ({
          ...el,
          label: el.userDetail.name,
        }))
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFleetById() {
      try {
        const { data } = await this.getFleetById(this.$route.query?.vehicleId)
        this.fleetSelected = data
        this.fleetsOptions = [{ text: data.name, value: data.id }]
        this.form.vehicle_id = data.id
      } catch (error) {
        console.log(error)
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    formatDate(date) {
      return date ? moment(date).format('DD MMM YYYY') : '-'
    },
    handleInputFiles(val, item) {
      if (!val) return false
      const files = val
      if (files.length) {
        Array.from(files).forEach((file) => {
          this.form.files.push(file)
          this.form.filePreview.push({
            url: URL.createObjectURL(file),
            name: file.name,
          })
        })
      }
    },
    handleDeleteFile(item, idx) {
      // this.deleted_files.push()
      const deletedFile = this.form.files.find((_, i) => i == idx)
      if (!(deletedFile instanceof File)) {
        this.form.deleted_files.push(deletedFile)
      }
      const newFiles = this.form.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = this.form.files.filter((_, i) => i !== idx)
      this.form.filePreview = newFiles
      this.form.files = newFileUploads
    },
    onInputPic(val, form) {
      const option = this.usersPic.find((el) => el.id == val)
      form.pic = option.label
    },
    deleteFile(path) {
      this.form.filePreview = this.form.filePreview.filter(
        (el) => el.path !== path
      )
    },
  },
  mounted() {
    this.fetchFleetById()
    this.fetchPic()
  },
}
</script>

<style scoped>
.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.black {
  color: black !important;
}
</style>
